import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getIcdPathologies } from '../../services/api';

export interface PathologiesState {
  pathologiesLists: {
    data: any;
    status: null | 'idle' | 'loading' | 'failed';
  };
  openAddPathologies: boolean;
  pathologySelected: null | any;
}

const initialState: PathologiesState = {
  pathologiesLists: {
    data: [],
    status: null,
  },
  openAddPathologies: false,
  pathologySelected: null,
};

export const getPathologiesAsync: any | null = createAsyncThunk(
  'pathologies/getPathologies',
  async (data: any, { getState, dispatch }) => {
    const state: any = getState();
    const params: any = {
      q: data.pathology + '%',
      includeKeywordResult: false,
      useFlexisearch: false,
      flatResults: true
    };
    const response = await getIcdPathologies(data, params, data.language);
    return response;
  },
);

export const pathologiesSlice = createSlice({
  name: 'pathologies',
  initialState,
  reducers: {
    setOpenAddPathologies: (state, action: PayloadAction<boolean>) => {
      state.openAddPathologies = action.payload;
    },
    setPathologySelected: (state, action: PayloadAction<any>) => {
      state.pathologySelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPathologiesAsync.pending, (state) => {
        state.pathologiesLists.status = 'loading';
      })
      .addCase(getPathologiesAsync.fulfilled, (state, action) => {
        state.pathologiesLists.data = action.payload?.data?.destinationEntities;
        state.pathologiesLists.status = 'idle';
      })
      .addCase(getPathologiesAsync.rejected, (state) => {
        state.pathologiesLists.status = 'failed';
      });
  },
});

export const { setOpenAddPathologies, setPathologySelected } = pathologiesSlice.actions;

export default pathologiesSlice.reducer;
